/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserEntitlementsRelation} from '../models/UpdateUserEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkProductAssignUserEntitlements$Request {
    updateUserEntitlementsRelation: UpdateUserEntitlementsRelation;
    reason?: string;
}

export interface BulkProductAssignUserEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkProductAssignUserEntitlementsRequest = createAction<PayloadData<void, BulkProductAssignUserEntitlements$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__REQUEST');
export const bulkProductAssignUserEntitlementsSuccess = createAction<PayloadData<string, BulkProductAssignUserEntitlements$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__SUCCESS');
export const bulkProductAssignUserEntitlementsFailure = createAction<PayloadData<Error, BulkProductAssignUserEntitlements$Request, true>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__FAILURE');

export const bulkProductAssignUserEntitlementsActions = [
    bulkProductAssignUserEntitlementsRequest,
    bulkProductAssignUserEntitlementsSuccess,
    bulkProductAssignUserEntitlementsFailure
] as const;

/**
 * @param {UpdateUserEntitlementsRelation} meta.updateUserEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkProductAssignUserEntitlements = (meta: BulkProductAssignUserEntitlements$Request, config?: BulkProductAssignUserEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkProductAssignUserEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductAssignUserEntitlementsProgress$Request {
    id: string;
}

export interface GetProductAssignUserEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductAssignUserEntitlementsProgressRequest = createAction<PayloadData<void, GetProductAssignUserEntitlementsProgress$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_PROGRESS__REQUEST');
export const getProductAssignUserEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetProductAssignUserEntitlementsProgress$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getProductAssignUserEntitlementsProgressFailure = createAction<PayloadData<Error, GetProductAssignUserEntitlementsProgress$Request, true>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_PROGRESS__FAILURE');

export const getProductAssignUserEntitlementsProgressActions = [
    getProductAssignUserEntitlementsProgressRequest,
    getProductAssignUserEntitlementsProgressSuccess,
    getProductAssignUserEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductAssignUserEntitlementsProgress = (meta: GetProductAssignUserEntitlementsProgress$Request, config?: GetProductAssignUserEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductAssignUserEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/users/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductAssignUserEntitlementsResult$Request {
    id: string;
}

export interface GetProductAssignUserEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductAssignUserEntitlementsResultRequest = createAction<PayloadData<void, GetProductAssignUserEntitlementsResult$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_RESULT__REQUEST');
export const getProductAssignUserEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetProductAssignUserEntitlementsResult$Request>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_RESULT__SUCCESS');
export const getProductAssignUserEntitlementsResultFailure = createAction<PayloadData<Error, GetProductAssignUserEntitlementsResult$Request, true>>('BULK_PRODUCT_ASSIGN_USER_ENTITLEMENTS__GET_PRODUCT_ASSIGN_USER_ENTITLEMENTS_RESULT__FAILURE');

export const getProductAssignUserEntitlementsResultActions = [
    getProductAssignUserEntitlementsResultRequest,
    getProductAssignUserEntitlementsResultSuccess,
    getProductAssignUserEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductAssignUserEntitlementsResult = (meta: GetProductAssignUserEntitlementsResult$Request, config?: GetProductAssignUserEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductAssignUserEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/users/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

